import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ISLATypesService } from "services/SLATypesService";
import { IntSelectModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  SLATypeSelectModels: new Array<IntSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const slaTypeSelectSLice = createSlice({
  name: "slaTypeSelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSLATypeSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getSLATypeSelectModels.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getSLATypeSelectModels.fulfilled, (state, action) => {
        state.SLATypeSelectModels = action.payload;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      });
  },
});

export const getSLATypeSelectModels = createAsyncThunk("SLATypeSelect/GetSelectModels", async () => {
  const slaTypesService = container.get<ISLATypesService>(SERVICE_TYPES.SLATypesService);
  return await slaTypesService.getSLATypeSelectModels();
});

export const selectSLATypeSelectModels = (state: RootState) => {
  return state.slaTypesSelect.SLATypeSelectModels;
};
export const selectLoading = (state: RootState) => {
  return state.slaTypesSelect.Loading;
};
export const selectLastUpdateTime = (state: RootState) => {
  return state.slaTypesSelect.LastUpdateTime;
};

export default slaTypeSelectSLice.reducer;
